export enum ServiceLocationType {
  LOCATION = "location", // Store location.
  PHONE = "phone", // Location is a phone number provided by the organiser.
  ADDRESS = "address", // In-person meeting address provided by the organiser.
  LINK = "link", // Location is a web link or meeting URL.
  COLLECT_PHONE = "collect_phone", // Location is a phone number provided by attendee. This is collected during booking.
  COLLECT_ADDRESS = "collect_address", // Location is an address provided by attendee. This is collected during booking.
}
